import React, { useState } from "react";
import { Box, Radio, RadioOption, Separator, Text } from "@showitinc/showit-wc";
import ViewPanel from "../../blogsetup/ViewPanel";
import SetupButtonBar from "../../blogsetup/SetupButtonBar";
import Constants from "../Constants";

function BlogChoice({ blogSetup, actions }) {
  const { isDomainSubmitting } = blogSetup;
  const [choice, setChoice] = useState(
    blogSetup.path === Constants.PATH_ADV_MIGRATE ? "migrate" : "new"
  );

  const proceed = () => {
    const isMigration = choice === "migrate";
    const newPath = isMigration ? Constants.PATH_ADV_MIGRATE : Constants.PATH_ADV_NEW;
    const configureDomain = isMigration
      ? Constants.CONFIGURE_DOMAIN_MIGRATE
      : Constants.CONFIGURE_DOMAIN_NEW;
    actions.submitDomainSetup(
      { configure_domain: configureDomain },
      {
        onSuccess: () => actions.choosePath({ path: newPath }),
        onError: () => actions.goToPrevStep(),
      }
    );
  };

  const btnText = isDomainSubmitting ? "Submitting..." : "Next";
  const btnAction = isDomainSubmitting ? undefined : proceed;

  return (
    <ViewPanel>
      {{
        content: (
          <>
            <Text variant="heading-2" variantStyle="strong">
              Blog Setup
            </Text>
            <Separator />
            <Text>Would you like to set up a new blog or migrate your existing blog?</Text>
            <Box my="3">
              <Radio>
                <RadioOption
                  name="blog_setup_type"
                  value="new"
                  label="Set up New Blog"
                  checked={choice === "new"}
                  onSIChange={() => setChoice("new")}
                />
                <RadioOption
                  name="blog_setup_type"
                  value="migrate"
                  label="Migrate Existing Blog"
                  checked={choice === "migrate"}
                  onSIChange={() => setChoice("migrate")}
                />
              </Radio>
            </Box>
          </>
        ),
        actions: (
          <SetupButtonBar
            onForward={btnAction}
            onBack={actions.goToPrevStep}
            allowForward={btnAction !== undefined}
            allowBack={!isDomainSubmitting}
            forwardBtnText={btnText}
          />
        ),
      }}
    </ViewPanel>
  );
}

export default BlogChoice;
